import "./Competitiondetail.css";
import {
  useParams,
  NavLink,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useMemo, useState, useEffect } from "react";
import star from "./star.png";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import hall from "../../competitionImage/hall.jpg";
import Skeleton from "../../../../components/Skeleton";
import worldCup from "../../../home/HomeImage/worldcup.png";
import { Helmet } from "react-helmet-async";
import Competitionnews from "../competitionnews/Competitionnews";
import Competitiontable from "../comptable/Competitiontable";
import Matches from "../matches/Matches";
import Competitionplayer from "../competitionplayer/Competitionplayer";

const CompDetail = ({ dark, MyBaseUrl }) => {
  const { name, id } = useParams();

  const [news, setNews] = useState([]);

  const [competition, setCompetition] = useState(null);
  const [loadingNews, setLoadingNews] = useState(true);

  const [loadingStands, setLoadingStands] = useState(true);

  const [matches, setMatches] = useState([]);
  const [loadingMatches, setLoadingMatches] = useState(true);

  const [players, setPlayers] = useState([]);
  const [loadingPlayers, setLoadingPlayers] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes("/news")) return "news";
    if (location.pathname.includes("/standings")) return "standings";
    if (location.pathname.includes("/matches")) return "matches";
    if (location.pathname.includes("/players")) return "players";
    return "overview";
  };

  const [activeTab, setActiveTab] = useState(() => getCurrentTab());

  const [standings, setStandings] = useState([]);
  const [leagueInfo, setLeagueInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [myFav, setMyFav] = useState({});

  const [isStickyTop, setIsStickyTop] = useState(false);

  const createSlug = (leagueName) => {
    return leagueName
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const createSlugName = (home, away) => {
    return `${home}-vs-${away}`
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoadingNews(true);
        setLoadingStands(true);
        setLoadingMatches(true);
        setLoadingPlayers(true);

        const realId = id;

        console.log(`realId: ${realId}`);

        const [newsRes, standRes, matchRes, playerRes] = await Promise.all([
          fetch(`${MyBaseUrl}/competitions/${realId}/news`),
          fetch(`${MyBaseUrl}/competitions/${realId}/standings`),
          fetch(`${MyBaseUrl}/competitions/${realId}/matches`),
          fetch(`${MyBaseUrl}/competitions/${realId}/top-players`),
        ]);

        const [newsData, standData, matchData, playerData] = await Promise.all([
          newsRes.json(),
          standRes.json(),
          matchRes.json(),
          playerRes.json(),
        ]);

        // API returns a `competition` object inside `newsData.data` alongside the news list
        setCompetition(
          newsData?.data?.competition || newsData?.data?.[0] || null,
        );

        setNews(newsData?.data?.data || []);

        const standingsArray = standData?.data?.[0]?.league?.standings || [];

        setStandings(standingsArray);

        setStandings(standingsArray);

        setMatches(matchData?.data || []);
        setPlayers(playerData?.data || []);
        setLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingNews(false);
        setLoadingStands(false);
        setLoadingMatches(false);
        setLoadingPlayers(false);
      }
    };
    if (id) {
      fetchNews();
    }
  }, [id, MyBaseUrl]);

  const tableData = Array.isArray(standings?.[0]) ? standings[0] : [];

  // use the competition object returned by the news endpoint as league data
  const leagueData = competition || {};
  const leagueId = leagueData?.id || id;
  const slug = createSlug(leagueData?.name || name);

  const country =
    competition?.country?.name || competition?.country || "Unknown Country";

  const currentSeason =
    competition?.season?.year ||
    competition?.seasons?.[0]?.year ||
    competition?.season ||
    "";

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const favorite = (matchId) => {
    setMyFav((prev) => ({
      ...prev,
      [matchId]: !prev[matchId],
    }));
  };

  const getBorderColor = (description) => {
    if (!description) return "4px solid transparent";

    const text = description.toLowerCase();

    if (text.includes("champions")) return "4px solid #16a34a";
    if (text.includes("europa")) return "4px solid #f97316";
    if (text.includes("conference")) return "4px solid #3b82f6";
    if (text.includes("promotion")) return "4px solid #16a34a";
    if (text.includes("relegation")) return "4px solid #ef4444";
    if (text.includes("ranking")) return "4px solid #a1a1aa";

    return "4px solid transparent";
  };

  useEffect(() => {
    setActiveTab(getCurrentTab());
  }, [location.pathname]);

  const fetchMatchesData = async () => {
    try {
      const matchRes = await fetch(`${MyBaseUrl}/competitions/${id}/matches`);
      const matchData = await matchRes.json();
      setMatches(matchData?.data || []);
    } catch (error) {
      console.error("Error fetching matches:", error);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    const routes = {
      overview: `/competition/${slug}/${leagueId}`,
      news: `/competition/${slug}/${leagueId}/news`,
      standings: `/competition/${slug}/${leagueId}/standings`,
      matches: `/competition/${slug}/${leagueId}/matches`,
      players: `/competition/${slug}/${leagueId}/players`,
    };

    // Refresh matches data when clicking on matches or overview tabs
    if (tab === "matches" || tab === "overview") {
      fetchMatchesData();
    }

    navigate(routes[tab]);
  };

  if (loading) {
    return <Skeleton dark={dark} />;
  }

  return (
    <div className="homer">
      <Helmet>
        <title>{`${leagueData?.name || name || "Competition"} | ${country} Football | Season ${currentSeason || "TBA"}`}</title>

        <meta
          name="description"
          content={`Follow ${leagueData?.name || name} live updates, standings, fixtures, top players, and latest news from ${country} Football Season ${currentSeason}.`}
        />

        <meta
          name="keywords"
          content={`${leagueData?.name}, ${country} football, standings, fixtures, matches, top players, season ${currentSeason}`}
        />

        <meta
          property="og:title"
          content={`${leagueData?.name || name} - Competition Overview`}
        />

        <meta
          property="og:description"
          content={`Live updates, standings, matches and news for ${leagueData?.name || name} in ${country} Football Season ${currentSeason}.`}
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={`${leagueData?.name || name} - Season ${currentSeason}`}
        />

        <meta
          name="twitter:description"
          content={`Live standings, matches, and stats for ${leagueData?.name || name}.`}
        />

        {leagueData?.logo && (
          <meta name="twitter:image" content={leagueData.logo} />
        )}
      </Helmet>

      <div className="compdetailsWrapper">
        <NavLink
          to="/competition"
          className="ppp"
          style={{ textDecoration: "none" }}>
          <strong
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: dark ? "none" : "none",
              color: dark ? "white" : "black",
              padding: "5px 10px",
              borderRadius: "5px",
            }}>
            <img
              src={whiteArrow}
              alt=""
              style={{
                filter: dark ? "none" : "invert(1)",
              }}
              className="whitearrow to"
            />
          </strong>
        </NavLink>

        <section
          className="section1"
          style={
            dark
              ? { backgroundColor: "#272727ff" }
              : { backgroundColor: "whitesmoke" }
          }>
          <div>
            <img
              src={leagueData?.id === 1 ? worldCup : leagueData?.logo}
              alt={leagueData?.name}
              style={{ backgroundColor: "white" }}
            />

            <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
              {leagueData?.name}
            </h1>
          </div>

          <span>
            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              {country} Football
            </strong>

            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              Season {currentSeason}
            </strong>
          </span>

          <nav>
            <ul
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <li
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : {
                        color:
                          activeTab !== "overview" ? "#3e3f3f" : "#fafafaff",
                      }
                }
                onClick={() => handleTabChange("overview")}
                className={activeTab === "overview" ? "active" : "navlink"}>
                Overview
              </li>

              <li
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : { color: activeTab !== "news" ? "#3e3f3f" : "#fafafaff" }
                }
                onClick={() => handleTabChange("news")}
                className={activeTab === "news" ? "active" : "navlink"}>
                News
              </li>

              <li
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : {
                        color:
                          activeTab !== "standings" ? "#3e3f3f" : "#fafafaff",
                      }
                }
                onClick={() => handleTabChange("standings")}
                className={activeTab === "standings" ? "active" : "navlink"}>
                Tables
              </li>

              <li
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : {
                        color:
                          activeTab !== "matches" ? "#3e3f3f" : "#fafafaff",
                      }
                }
                onClick={() => handleTabChange("matches")}
                className={activeTab === "matches" ? "active" : "navlink"}>
                Matches
              </li>

              <li
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : {
                        color:
                          activeTab !== "players" ? "#3e3f3f" : "#fafafaff",
                      }
                }
                onClick={() => handleTabChange("players")}
                className={activeTab === "players" ? "active" : "navlink"}>
                Top Players
              </li>
            </ul>
          </nav>
        </section>

        {activeTab === "overview" && (
          <>
            <div className="overviewWrapper">
              <section className="section2">
                <h1 style={dark ? { color: "#f8f8f8ff" } : {}}>Overview</h1>
                <p style={dark ? { color: "#e4e4e4ff" } : { color: "#6E6E6E" }}>
                  Watch your favorite team compete in real-time. Tune in now and
                  experience the thrill of {country} football - live, Watch your
                  favorite team compete in real-time. The tournament is played
                  in a cup format, featuring a group stage followed by knockout
                  rounds that culminate in the final match where the champion is
                  crowned.
                </p>
              </section>

              {!loadingNews && news?.length > 0 && (
                <section className="thirdsection">
                  {loadingNews && <></>}

                  {news === null && <a></a>}

                  <>
                    <NavLink
                      to={`/competition/${slug}/${leagueId}/news`}
                      style={{ textDecoration: "none" }}
                      className={({ isActive }) =>
                        isActive ? "active" : "navlink"
                      }>
                      <h1
                        style={
                          dark ? { color: "#f8f8f8ff" } : { color: "#161819" }
                        }>
                        Featured News
                        <img
                          src={whiteArrow}
                          alt=""
                          style={{
                            filter: dark ? "none" : "invert(1)",
                          }}
                          className="whitearrow to"
                        />
                      </h1>
                    </NavLink>

                    <menu className="rom">
                      <section className="slider">
                        {news?.slice(0, 5)?.map((item, index) => (
                          <NavLink to={`/news/${item?.slug}`} className="new">
                            <div key={item?.id || index}>
                              <nav>
                                <img
                                  src={
                                    item?.image !== null ? item?.image : hall
                                  }
                                  alt={item?.title}
                                />
                              </nav>

                              <nav className="con deep">
                                {/* <h3>{item?.categories?.[0]?.name}</h3> */}
                                <h2>{item?.title}</h2>
                              </nav>
                            </div>
                          </NavLink>
                        ))}
                      </section>
                    </menu>
                  </>
                </section>
              )}

              <section className="overall">
                {loadingStands || standings.length <= 0 ? (
                  <></>
                ) : (
                  <>
                    <NavLink
                      to={`/competition/${slug}/${leagueId}/standings`}
                      style={{ textDecoration: "none" }}
                      className={({ isActive }) =>
                        isActive ? "active" : "navlink"
                      }>
                      <h1
                        style={
                          dark ? { color: "#fafafaff" } : { color: "#161819" }
                        }>
                        Table
                        <img
                          src={whiteArrow}
                          alt=""
                          style={{
                            filter: dark ? "none" : "invert(1)",
                          }}
                          className="whitearrow to"
                        />
                      </h1>
                    </NavLink>

                    <div className="tablehead">
                      <nav>
                        <h2>POS</h2>
                        <h2>TEAM</h2>
                      </nav>
                      <span>
                        <h2 style={{ color: "white" }}>P</h2>
                        <h2 style={{ color: "white" }}>W</h2>
                        <h2 style={{ color: "white" }}>D</h2>
                        <h2 style={{ color: "white" }}>L</h2>
                        <h2 style={{ color: "white" }}>GD</h2>
                        <h2 style={{ color: "white" }}>PTS</h2>
                      </span>
                    </div>

                    <section className="onlysection standings">
                      {tableData.slice(0, 5).map((teamData, index) => (
                        <div
                          key={teamData?.team?.id || index}
                          style={
                            dark
                              ? {
                                  backgroundColor: "#333333ff",
                                  color: "#fff",
                                  borderRadius: "30px",
                                  borderLeft: getBorderColor(
                                    teamData?.description,
                                  ),
                                }
                              : {
                                  borderLeft: getBorderColor(
                                    teamData?.description,
                                  ),
                                }
                          }>
                          <nav>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#474545" }
                              }>
                              {teamData?.rank}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#e4e4e4ff" }
                                  : { color: "#474545" }
                              }>
                              <NavLink
                                key={index}
                                to={`/teams/${createSlug(standings?.team?.name)}-${standings?.team?.id}`}>
                                <img
                                  src={teamData?.team?.logo}
                                  width="20"
                                  alt={teamData?.team?.name}
                                />
                              </NavLink>

                              <NavLink
                                key={index}
                                to={`/teams/${createSlug(teamData?.team?.name)}-${teamData?.team?.id}`}>
                                <span
                                  className="longName"
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.team?.code}
                                </span>

                                <span
                                  className="codeName"
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.team?.code}
                                </span>
                              </NavLink>
                            </h2>
                          </nav>

                          <span>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.played}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.win}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.draw}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.all?.lose}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.goalsDiff}
                            </h2>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafae0" }
                                  : { color: "#3e3f3f" }
                              }>
                              {teamData?.points}
                            </h2>
                          </span>
                        </div>
                      ))}
                    </section>
                  </>
                )}
              </section>
            </div>

            <section className="match">
              {!loadingMatches && matches?.length > 0 && (
                <NavLink
                  to={`/competition/${slug}/${leagueId}/matches`}
                  style={{ textDecoration: "none" }}
                  className={({ isActive }) =>
                    isActive ? "active" : "navlink"
                  }>
                  <h1
                    style={dark ? { color: "#fafafa" } : { color: "#161819" }}>
                    Matches
                    <img
                      src={whiteArrow}
                      alt=""
                      style={{
                        filter: dark ? "none" : "invert(1)",
                      }}
                      className="whitearrow to"
                    />
                  </h1>
                </NavLink>
              )}

              {loadingMatches ? (
                <p></p>
              ) : (
                matches?.slice(0, 5)?.map((match, index) => {
                  const home = match?.teams?.home;
                  const away = match?.teams?.away;
                  const goals = match?.goals;
                  const matchId = match?.fixture?.id;

                  return (
                    <div
                      key={matchId || index}
                      className="matchtable"
                      style={
                        dark
                          ? { backgroundColor: "#333333ff", boxShadow: "none" }
                          : {}
                      }>
                      <span
                        className={
                          match?.fixture?.status?.elapsed > 0 &&
                          match?.fixture?.status?.elapsed < 90 &&
                          match?.fixture?.status?.short !== "FT"
                            ? "live-time"
                            : ""
                        }
                        style={
                          match?.fixture?.status?.elapsed > 0 &&
                          match?.fixture?.status?.elapsed < 90 &&
                          match?.fixture?.status?.short !== "FT"
                            ? {}
                            : dark
                              ? { color: "#dfdfdfff" }
                              : { color: "#3e3f3f" }
                        }>
                        {match?.score?.penalty?.home !== null ||
                        match?.score?.penalty?.away !== null
                          ? "PK"
                          : match?.score?.extratime?.home !== null ||
                              match?.score?.extratime?.away !== null
                            ? "Extra"
                            : match?.fixture?.status?.short === "FT" ||
                                match?.fixture?.status?.elapsed >= 90
                              ? "FT"
                              : match?.fixture?.status?.elapsed
                                ? `${
                                    match.fixture.status.elapsed >= 90 &&
                                    match.fixture.status.extra
                                      ? `${match.fixture.status.elapsed}<sup>+${match.fixture.status.extra}</sup>`
                                      : match.fixture.status.elapsed
                                  }'`
                                : match?.fixture?.status?.short === "NS"
                                  ? new Date(
                                      match?.fixture?.date,
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    })
                                  : match?.fixture?.status?.short}
                      </span>

                      <NavLink
                        key={match.fixture.id}
                        to={`/matches/${createSlug(
                          match.teams.home.name,
                          match.teams.away.name,
                        )}/${match.fixture.id}`}
                        state={{ matchId }}
                        style={{ width: "100%" }}>
                        <spam
                          className="matchspam"
                          style={{ backgroundColor: "transparent" }}>
                          <nav style={{ backgroundColor: "transparent" }}>
                            <wrap className="MM">
                              <img
                                src={match?.teams?.home?.logo}
                                width="25"
                                alt={match?.teams?.home?.name}
                              />
                              <p
                                style={
                                  dark
                                    ? { color: "#dbdbdbff" }
                                    : { color: "#161819" }
                                }>
                                {match?.teams?.home?.name}
                              </p>
                            </wrap>

                            {match?.fixture?.status?.short !== "NS" &&
                              match?.fixture?.status?.short !== "CANC" && (
                                <wrap className="NN">
                                  <strong
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {goals?.home}
                                  </strong>
                                </wrap>
                              )}
                          </nav>

                          <nav style={{ backgroundColor: "transparent" }}>
                            <wrap className="MM">
                              <img
                                src={match?.teams?.away?.logo}
                                width="25"
                                alt={match?.teams?.away?.name}
                              />
                              <p
                                style={
                                  dark
                                    ? { color: "#dbdbdbff" }
                                    : { color: "#161819" }
                                }>
                                {match?.teams?.away?.name}
                              </p>
                            </wrap>

                            {match?.fixture?.status?.short !== "NS" &&
                              match?.fixture?.status?.short !== "CANC" && (
                                <wrap className="NN">
                                  <strong
                                    style={
                                      dark
                                        ? { color: "#dbdbdbff" }
                                        : { color: "#161819" }
                                    }>
                                    {goals?.away}
                                  </strong>
                                </wrap>
                              )}
                          </nav>
                        </spam>
                      </NavLink>

                      <img
                        src={star}
                        alt=""
                        className={myFav[matchId] ? "star" : "nostar"}
                        onClick={() => favorite(matchId)}
                      />
                    </div>
                  );
                })
              )}
            </section>

            <section className="players">
              <>
                {!loadingPlayers && players.length > 0 && (
                  <NavLink
                    to={`/competition/${slug}/${leagueId}/players`}
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) =>
                      isActive ? "active" : "navlink"
                    }>
                    <h1
                      style={
                        dark ? { color: "#fafafa" } : { color: "#161819" }
                      }>
                      Top Players
                      <img
                        src={whiteArrow}
                        alt=""
                        style={{
                          filter: dark ? "none" : "invert(1)",
                        }}
                        className="whitearrow to"
                      />
                    </h1>
                  </NavLink>
                )}

                {loadingPlayers ? (
                  <p style={{ marginTop: "-150px", minWidth: "100%" }}>
                    <Skeleton dark={dark} count={2} />
                  </p>
                ) : players.length <= 0 ? (
                  <></>
                ) : (
                  <div className="playersGrid">
                    {players?.slice(0, 10)?.map((player, index) => {
                      const p = player?.player;
                      const stats = player?.statistics?.[0];
                      const team = stats?.team;

                      return (
                        <div className="playerRow" key={p?.id || index}>
                          <NavLink
                            to={`/players/${p.name
                              ?.trim()
                              .replace(/[^a-zA-Z.\s]/g, "")
                              .replace(/\s+/g, "-")
                              .toLowerCase()}-${p.id}`}
                            state={{ player: p, leagueSlug: slug }}
                            key={player.id || index}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}>
                            <div
                              className="playerCard"
                              style={
                                dark ? { backgroundColor: "#1a1a1a" } : {}
                              }>
                              <img src={p?.photo} alt={p?.name} />
                              <nav>
                                <h3>{p?.name}</h3>
                                <p>{team?.name}</p>
                              </nav>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
                    <NavLink
                      to={`/competition/${slug}/${leagueId}/players`}
                      style={{ textDecoration: "none" }}>
                      <div className="more">
                        <p>See all players</p>

                        <img src={whiteArrow} alt="" className="whitearrow" />
                      </div>
                    </NavLink>
                  </div>
                )}
              </>
            </section>
          </>
        )}

        {activeTab === "news" && (
          <Competitionnews
            dark={dark}
            news={news}
            loading={loadingNews}
            competition={competition}
            MyBaseUrl={MyBaseUrl}
          />
        )}

        {activeTab === "standings" && (
          <Competitiontable
            dark={dark}
            standings={standings}
            loading={loadingStands}
            competition={competition}
          />
        )}

        {activeTab === "matches" && (
          <Matches
            dark={dark}
            matches={matches}
            loading={loadingMatches}
            competition={competition}
          />
        )}

        {activeTab === "players" && (
          <Competitionplayer
            dark={dark}
            players={players}
            loading={loadingPlayers}
            competition={competition}
          />
        )}
      </div>
    </div>
  );
};

export default CompDetail;
